import { z } from 'zod';
export const PluginBaseSchemaDefinition = z.object({
    name: z.string(),
    slug: z.string(),
    description: z.string().optional(),
    args: z.string().optional(),
    dependencies: z.record(z.string()).optional(),
    devDependencies: z.record(z.string()).optional(),
});
const FieldAttachedType = z.literal('FieldAttached');
export const FieldAttachedPluginSchema = z.object({ type: FieldAttachedType }).merge(PluginBaseSchemaDefinition);
const BasicType = z.literal('Basic');
export const BasicSchema = z.object({ type: BasicType }).merge(PluginBaseSchemaDefinition);
export const PluginSchemaDefinition = z.discriminatedUnion('type', [FieldAttachedPluginSchema, BasicSchema]);
//# sourceMappingURL=plugins-definitions.js.map